// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uNxV","label":"styles_label__3DdWH"};